import { CALL_API } from "admin/middlewares/api";

export const GET_AUTO_INVEST_STATUS_REQUEST = "GET_AUTO_INVEST_STATUS_REQUEST";
export const GET_AUTO_INVEST_STATUS_SUCCESS = "GET_AUTO_INVEST_STATUS_SUCCESS";
export const GET_AUTO_INVEST_STATUS_ERROR = "GET_AUTO_INVEST_STATUS_ERROR";

export function get_auto_invest_status() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/smartinvest/enabled",
      authenticatedRequest: true,
      types: [
        GET_AUTO_INVEST_STATUS_REQUEST,
        GET_AUTO_INVEST_STATUS_SUCCESS,
        GET_AUTO_INVEST_STATUS_ERROR,
      ],
    },
  };
}

export const ENABLE_AUTO_INVEST_REQUEST = "ENABLE_AUTO_INVEST_REQUEST";
export const ENABLE_AUTO_INVEST_SUCCESS = "ENABLE_AUTO_INVEST_SUCCESS";
export const ENABLE_AUTO_INVEST_ERROR = "ENABLE_AUTO_INVEST_ERROR";

export const DISABLE_AUTO_INVEST_REQUEST = "DISABLE_AUTO_INVEST_REQUEST";
export const DISABLE_AUTO_INVEST_SUCCESS = "DISABLE_AUTO_INVEST_SUCCESS";
export const DISABLE_AUTO_INVEST_ERROR = "DISABLE_AUTO_INVEST_ERROR";

export function switch_auto_invest(currentValue) {
  var types = currentValue
    ? [
        DISABLE_AUTO_INVEST_REQUEST,
        DISABLE_AUTO_INVEST_SUCCESS,
        DISABLE_AUTO_INVEST_ERROR,
      ]
    : [
        ENABLE_AUTO_INVEST_REQUEST,
        ENABLE_AUTO_INVEST_SUCCESS,
        ENABLE_AUTO_INVEST_ERROR,
      ];

  var uri = currentValue ? "/smartinvest/disable" : "/smartinvest/enable";

  return {
    [CALL_API]: {
      endpoint: "/api/admin" + uri,
      authenticatedRequest: true,
      method: "POST",
      types,
    },
  };
}
